var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Form',{attrs:{"form":_vm.form,"form-data":_vm.formData,"form-entry":_vm.formEntry,"is-organizer":_vm.isOrganizer,"tile-layout":"","data-no-anchor-interceptor":""},on:{"form-changed":_vm.onFormChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }